$(document).ready(function() {
  // Initialize: disable achievement fields if experience level is not selected
  // Only applies to new records (selects exist), not edit records (text fields)
  var initial_experience_level = $('#experience-level').val();
  var tqg_incentive_trip_id = $('#tqg-incentive-trip-id').val();

  // Check if select elements exist (they only exist for new records)
  if ($('#min-achievement-id').length > 0) {
    if (!initial_experience_level || initial_experience_level === '') {
      $('#min-achievement-id').prop('disabled', true);
      $('#max-achievement-id').prop('disabled', true);
    } else {
      // If experience level is already selected, populate min achievements
      getMinTier(tqg_incentive_trip_id, initial_experience_level);
    }
  }

  $('#experience-level').change(function() {
    var experience_level = $(this).val();
    var tqg_incentive_trip_id = $('#tqg-incentive-trip-id').val();

    // Only handle if select elements exist (new records only)
    if ($('#min-achievement-id').length === 0) {
      return;
    }

    if (experience_level === '' || experience_level === null) {
      // Reset achievement fields if no experience level selected
      $('#min-achievement-id').val('').prop('disabled', true).trigger('change');
      $('#max-achievement-id').val('').prop('disabled', true).trigger('change');
      $('#achievement-tier-detail').empty();
      return;
    }

    getMinTier(tqg_incentive_trip_id, experience_level);
  });

  $('#max-achievement-id').change(function() {
    var max_achievement_id = $(this).val();
    var min_achievement = $('#min-achievement-id option:selected').text();
    var max_achievement = $(this).find('option:selected').text();

    if (max_achievement_id && max_achievement_id !== '') {
      // Build alert message with tier range
      var alert_text = I18n.t('global.notices.user_with_level') + ` ${min_achievement} - ${max_achievement} ` + I18n.t('global.notices.have_the_opportunity_to_qualify_this_incentive_trip');
      $('#range_tiers').data('range-tier', `Are you sure ? \n ${alert_text}`);
      $('#achievement-tier-detail').html(`#${alert_text}`);
    } else {
      $('#range_tiers').data('range-tier', '');
      $('#achievement-tier-detail').empty();
    }
  })

  $('#min-achievement-id').change(function() {
    var min_achievement_id = $(this).val();
    if (min_achievement_id && min_achievement_id !== '') {
      // Enable max achievement field and update options
      $('#max-achievement-id').prop('disabled', false);
      updateAchievementMaxOptions(min_achievement_id);
    } else {
      // Disable max achievement field if min is cleared
      $('#max-achievement-id').val('');
      $('#max-achievement-id').empty();
      $('#max-achievement-id').append("<option value>Select Maximum Achievement</option>");
      $('#max-achievement-id').prop('disabled', true);
      $('#achievement-tier-detail').empty();
    }
  })

  $('.btn-save-tqg-qualification').click(function() {
    if (!$('#max-achievement-id')[0].disabled) {
      var range_tiers = $('#range_tiers').data('range-tier');

      if (!!$('#max-achievement-id').val()) {
        // Only show confirm if range_tiers data exists and has content
        if (range_tiers && range_tiers.trim() !== '') {
          if (confirm(range_tiers) == false) {
            return false;
          }
        }
      }
    }
  })

  function getMinTier(tqg_incentive_trip_id, experience_level) {
    if (!experience_level || experience_level === '' || $('#min-achievement-id').length === 0) {
      return;
    }

    $.ajax({
      type: "GET",
      dataType:"json",
      data: {
        'tqg_incentive_trip_id': tqg_incentive_trip_id,
        'experience_level': experience_level
      },
      url: `/admin/tqg_incentive_trips/${tqg_incentive_trip_id}/tqg_incentive_qualifications/get_min_achievement_options`,
      success: function(response){
        // Enable and populate minimum achievement options
        if (response.min_achievements && response.min_achievements.length > 0) {
          $('#min-achievement-id').prop('disabled', false);
          $('#min-achievement-id').val('');
          $('#min-achievement-id').empty();
          $('#min-achievement-id').append("<option value>Select Minimum Achievement</option>");

          $.each(response.min_achievements, function(_key, data) {
            let option = $("<option></option>");
            option.attr("value", data.id);
            option.text(data.level_name);
            $('#min-achievement-id').append(option);
          });

          // Clear maximum achievement options until min is selected
          if ($('#max-achievement-id').length > 0) {
            $('#max-achievement-id').val('');
            $('#max-achievement-id').empty();
            $('#max-achievement-id').append("<option value>Select Maximum Achievement</option>");
            $('#max-achievement-id').prop('disabled', true);
          }
        } else {
          $('#min-achievement-id').prop('disabled', true);
          if ($('#max-achievement-id').length > 0) {
            $('#max-achievement-id').prop('disabled', true);
          }
        }

        $('#achievement-tier-detail').empty();
      },
      error: function(xhr, status, error) {
        console.error('Error fetching minimum achievement options:', error);
      }
    });
  }

  function updateAchievementMaxOptions(min_achievement_id) {
    var tqg_incentive_trip_id = $('#tqg-incentive-trip-id').val();

    $.ajax({
      type: "GET",
      dataType:"json",
      data: { 'min_achievement_id' : min_achievement_id },
      url: `/admin/tqg_incentive_trips/${tqg_incentive_trip_id}/tqg_incentive_qualifications/get_max_achievement_options`,
      success: function(response){
        $('#max-achievement-id').val('');
        $('#max-achievement-id').empty();
        $('#achievement-tier-detail').empty();

        max_achievements = response.max_achievements;
        $('#max-achievement-id').append("<option value>"+ I18n.t('actions.select', {item: I18n.t('global.maximum_achievement')}) +"</option>");

        $.each(max_achievements, function(_key, data) {
          let option = $("<option></option>");
              option.attr("value", data.id);
              option.text(data.level_name);

          $('#max-achievement-id').append(option);
        })
      }
    });
  }

  $('.btn-save-tqg-incentive-trip').click(function() {
    if ($('#tqg-incentive-banner-preview').length >= 1) {
      return true;
    }

    if (!$('#tqg_incentive_trip_banner').val()) {
      alert(I18n.t('global.alerts.banner_cant_be_blank'))
      return false;
    }
  })

  // Filter chart
  $('#filter-by-chart_period').change(function(){
    $('#submit-filter-by-chart-period').click();

    if ($('#input-chart-period').val() == "all") {
      setTimeout(() => {
        $(".label-current-date").hide();
        return false;
      }, 100);
    }
  })

  // $('select#chart_period').on('change', function() {
  //   var selectedDate = $("select#chart_period").children("option:selected").val();

  //   if (selectedDate == "all") {
  //     $(".label-current-date").hide();
  //     // return false;
  //   }
  // });

  // Filter user pv activity
  $(".custom-select-item").click(function (e) {
    e.stopPropagation();
    $(".user-pv-select-options").toggle();
  });

  $(".user-pv-select-option").click(function () {
    const selectedText = $(this).text();
    $(".select-label").text(selectedText);
    $(".user-pv-select-options").hide();
  });

  $(document).click(function () {
    $(".user-pv-select-options").hide();
  });

  $(".hoverable").hover(
    function () {
      $(this).find(".monthly-options").show();
    },
    function () {
      $(this).find(".monthly-options").hide();
    }
  );

  // $('.user-pv-select-option').click(function(){
  //   $('#input-filter-user-pv-activity').val($(this).attr('value'));
  //   $('#submit-filter-by-user-pv-activity').click();
  // })

  $('#filter-activity-by-month').change(function(){
    $('#submit-filter-by-user-pv-activity').click();
  })
});
